export const state = {
  typeToLayer: {
    0: 'PlanetScope',
    1: 'PlanetVars',
    2: 'PlanetSkySat'
  },
  layers: [],
  dates: [],
  selectedRange: null,
  orgLayers: {},
  selectedFeature: {
    feature: null,
    coordinates: null,
    isVisible: false
  },
  // Track active result per layer for chart-map interaction
  activeResults: {},
  // Batch-fetched subscription results by orgId and layerCode
  subscriptionResults: {},
  // PlanetScope mosaic selection per layer (detail page writes, sidebar variant reads)
  planetscopeSelection: {},
  // Order product bundle selection per layer (detail page writes, sidebar variant reads)
  orderProductBundle: {}
}
